<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="医生:">
                    <el-select v-model="formData.docname" placeholder="请选择" size="small" filterable clearable >
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="性别:">
                    <el-select v-model="formData.sexname" placeholder="请选择" size="small" filterable clearable >
                        <el-option  label="男" value="1"></el-option>
                         <el-option  label="女" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="病种:">
                    <el-select v-model="formData.bzname" placeholder="请选择" size="small" filterable clearable >
                        <el-option v-for="item in  formData.bz_options" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_time" label="日期" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="show_name" label="医生" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="patient_name" label="用户姓名" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="patient_sex_text" label="性别" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="patient_birthday" label="年龄" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="手机号" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="consulting_text" label="是否咨询过" show-overflow-tooltip></el-table-column>
                <el-table-column prop="consulting_time" label="上次咨询时间" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="describe" label="病种描述" show-overflow-tooltip></el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData:{
                    time:'',
                    docname:'',
                    doc_options:[],
                    sexname:'',
                    bzname:'',
                    bz_options:[],
                },
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getall()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/DoctorQrcodeOrder/userBdDetail", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time:this.formData.time[0]?this.formData.time[0]:'',
                        end_time:this.formData.time[1]?this.formData.time[1]:'',
                        sex:this.formData.sexname,
                        icd_id:this.formData.bzname,
                        doc_id:this.formData.docname,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getall(){
                this.getdoc()
                this.getbzxx()
            },
            getdoc(){
                 axios
                    .post("/admin/doctorAssistantList", { }, {
                        token: true
                    })
                    .then(response => {
                      this.formData.doc_options=response.data.data
                    })
                    .catch(error => {})
            },
            getbzxx(){
                  axios
                    .post("/admin/KkysKnowledgeDisease/showDiseaseList", { }, {
                        token: true
                    })
                    .then(response => {
                        this.formData.bz_options=response.data.data
                    })
                    .catch(error => {})
            },
             //省
            all_sheng() {
                let that = this
                axios 
                    .post("/admin/Area/getProvince_vue", {
                    },{
                        token:true
                    })
                    .then(response => {
                        that.formData.pro_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 市
            getsq() {
                let that = this
                that.formData.city=''
                that.formData.city_options = []
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.formData.province,
                    },{
                        token:true
                    })
                    .then(response => {
                        that.formData.city_options = response.data.data
                    })
                    .catch(error => {})
            },
            


        },

    };
</script>


<style>

</style>